import { FC } from 'react';
import { format } from 'date-fns';
import { useTranslate } from 'hooks/useTranslate';

import { Note } from 'types';

import { DATE_FORMAT_WITH_TIME } from 'constants/defaultConstants';

import ToggleMenu from 'modules/_shared/components/ToggleMenu';
import TableRow from 'modules/_shared/Table/components/TableRow';
import { RowCell } from 'modules/_shared/Table/types/RowCell';

import { useNotesSection } from '../context/NotesSectionContext';

type NotesSectionTableRowProps = {
  index: number;
  note: Note;
};

const NotesSectionTableRow: FC<NotesSectionTableRowProps> = ({
  index,
  note,
}) => {
  const { t } = useTranslate();

  const { data, actions } = useNotesSection();

  const handleEdit = () => {
    actions.handleEditNote(note);
  };

  const handleDelete = () => {
    if (note?._id) {
      actions.handleDeleteNote(note._id);
    }
  };

  const toggleOptions = [
    <a
      className="d-flex cursor-pointer"
      key={`note-edit-option-${index}`}
      onClick={handleEdit}
    >
      <em className="icon ni ni-edit fs-20px" />
      <span className="ml-1">{t('Edit')}</span>
    </a>,

    <a
      className="d-flex cursor-pointer"
      key={`note-delete-option-${index}`}
      onClick={handleDelete}
    >
      <em className="icon ni ni-trash fs-20px" />
      <span className="ml-1">{t('Delete')}</span>
    </a>,
  ];

  const hasOptions = data.isAdmin && !data.isReadOnly;

  const cells = [
    {
      key: `note-date-${index}`,
      content: format(new Date(note.date), DATE_FORMAT_WITH_TIME),
      className: 'w-150px',
    },
    {
      key: `note-text-${index}`,
      content: note.text,
    },

    hasOptions
      ? {
          key: `note-options-${index}`,
          content: <ToggleMenu toggleOptions={toggleOptions} />,
          textPosition: 'center',
          className: 'w-30px',
        }
      : null,
  ].filter(Boolean) as RowCell[];

  return <TableRow cells={cells} />;
};

export default NotesSectionTableRow;
